module.exports = __webpack_public_path__ + "static/media/ford1.50822c7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ford/images/ford1.jpg
// module id = 87
// module chunks = 0